// extracted by css-extract-rspack-plugin
export default {"root":"QB3Fo","label":"WzMo8","inner":"CXv0i","leftSection":"VVu1r","rightSection":"hpBqT"};